import React, { useEffect, useState, useContext } from "react"
import _ from "lodash"
import { apiService } from "../../../api/axiosInstance"
import { Dropdown } from "primereact/dropdown"

import { SearchCtx } from "../context/searchCtx"

// constants
import { GET } from "../../../config/constants"

import { LoaderSkeleton } from "../../../components/Loaders"
import logger from "../../../services/logger"

export default function IndexFile() {
  const searchCtx = useContext(SearchCtx)

  const [fetching, setFetching] = useState(true)
  const [orderList, setOrderList] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      setFetching(true)
      try {
        const result = await apiService.post(`/${GET.MRF_ORDER_INDEX_LIST}`, {
          type: "dropdown",
          carrier_for_order: searchCtx.carrier,
        })
        setOrderList(result.data.data)
        setFetching(false)
      } catch (error) {
        logger.error("Error fetching MRF Order index list", error)
      }
    }
    fetchData()
  }, [searchCtx.carrier])

  if (fetching) return <LoaderSkeleton count={1} wrapper={false} />

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <label htmlFor="index_select">Select Table of Contents</label>
      <Dropdown
        id="index_select"
        options={orderList}
        value={searchCtx.index}
        onChange={(e) => searchCtx.setIndex(e.value)}
      />
    </div>
  )
}
